/* eslint no-undef: off */
import { translate, exist, interpolate } from '../translations';

window.$ = window.$ || {};

$.t = translate;
$.t.format = interpolate;
$.t.exist = exist;
